import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_marine-polish-1/artifacts/48cc9t5c_IMG_E3857%5B1%5D.JPG";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      className="bg-[#0B1E36] text-white"
      data-testid="footer">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Logo & Tagline */}
          <div className="lg:col-span-2" data-testid="footer-brand">
            <img
              src={LOGO_URL}
              alt="Deep Clean Detailers"
              className="h-16 w-auto mb-4"
              data-testid="footer-logo" />

            <p className="text-white/70 max-w-sm">
              Professional mobile boat detailing services. We bring the clean to you, wherever your vessel is docked.
            </p>
          </div>

          {/* Quick Links */}
          <div data-testid="footer-links">
            <h4
              className="text-[#FACC15] font-semibold mb-4 text-sm tracking-wider uppercase"
              style={{ fontFamily: "'Outfit', sans-serif" }}>

              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              <button
                onClick={() => scrollToSection("#services")}
                className="text-white/70 hover:text-white transition-colors text-left"
                data-testid="footer-link-services">

                Services
              </button>
              <button
                onClick={() => scrollToSection("#pricing")}
                className="text-white/70 hover:text-white transition-colors text-left"
                data-testid="footer-link-pricing">

                Pricing
              </button>
              <button
                onClick={() => scrollToSection("#about")}
                className="text-white/70 hover:text-white transition-colors text-left"
                data-testid="footer-link-about">

                About Us
              </button>
              <button
                onClick={() => scrollToSection("#contact")}
                className="text-white/70 hover:text-white transition-colors text-left"
                data-testid="footer-link-contact">

                Get a Quote
              </button>
            </nav>
          </div>

          {/* Contact Info */}
          <div data-testid="footer-contact">
            <h4
              className="text-[#FACC15] font-semibold mb-4 text-sm tracking-wider uppercase"
              style={{ fontFamily: "'Outfit', sans-serif" }}>

              Contact
            </h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-white/70">
                <Phone className="w-5 h-5 text-[#FACC15] flex-shrink-0" />
                <span>301-616-5560</span>
              </div>
              <div className="flex items-center gap-3 text-white/70">
                <Mail className="w-5 h-5 text-[#FACC15] flex-shrink-0" />
                <span>contact.deepcleandetailers@gmail.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="border-t border-white/10 mt-12 pt-8 text-center text-white/50 text-sm"
          data-testid="footer-copyright">

          <p>&copy; {currentYear} Deep Clean Detailers. All rights reserved.</p>
        </div>
      </div>
    </footer>);

}